import type { CSSProperties, ReactNode } from "react";
import { colors, fontSize, fontWeight, radius, shadow, space } from "../lib/tokens";

interface KpiProps {
  label: string;
  value: ReactNode;
  delta?: { direction: "up" | "down" | "flat"; text: string };
  sub?: string;
}

export function Kpi({ label, value, delta, sub }: KpiProps) {
  const card: CSSProperties = {
    background: colors.white,
    border: `1px solid ${colors.fog}`,
    borderRadius: radius.md,
    padding: `${space.lg + 2}px ${space.xl}px`,
    boxShadow: shadow.xs,
  };
  const labelStyle: CSSProperties = {
    fontSize: fontSize.xs,
    fontWeight: fontWeight.semibold,
    textTransform: "uppercase",
    letterSpacing: "0.06em",
    color: colors.stone,
    marginBottom: space.sm,
  };
  const valueStyle: CSSProperties = {
    fontSize: "24px",
    fontWeight: fontWeight.medium,
    letterSpacing: "-0.015em",
    color: colors.ink,
    lineHeight: 1.1,
    fontFeatureSettings: '"tnum" on',
  };
  const deltaColor = delta?.direction === "up"
    ? colors.success
    : delta?.direction === "down"
    ? colors.error
    : colors.stone;
  const deltaStyle: CSSProperties = {
    marginTop: 6,
    fontSize: fontSize.sm,
    fontWeight: fontWeight.medium,
    color: deltaColor,
  };
  const subStyle: CSSProperties = {
    fontSize: fontSize.sm,
    color: colors.stoneSoft,
    marginTop: 4,
  };
  return (
    <div style={card}>
      <div style={labelStyle}>{label}</div>
      <div style={valueStyle}>{value}</div>
      {delta && <div style={deltaStyle}>{delta.direction === "up" ? "↑" : delta.direction === "down" ? "↓" : "→"} {delta.text}</div>}
      {!delta && sub && <div style={subStyle}>{sub}</div>}
    </div>
  );
}
